import NextLink from 'next/link';

import { useClient } from '@playbooks/contexts';
import { cn } from '@playbooks/ui/lib/utils';

const MktLogo = ({ alt = 'Playbooks', collapsed = false, className = '' }) => {
	const { platformHref, clientHref } = useClient();
	const brandIcon = clientHref('web', '/branding/playbooks-icon.svg');
	const brandLogo = clientHref('web', '/branding/playbooks-logo.svg');
	const brandLogoDark = clientHref('web', '/branding/playbooks-logo-dark.svg');

	// Theme
	const classNames = {
		root: cn('flex-start shrink-0 hover:opacity-80', className),
		logo: cn('h-auto w-36', collapsed && 'w-8'),
		lightLogo: cn('h-auto w-36 dark:hidden', collapsed && 'w-8'),
		darkLogo: cn('h-auto w-36 hidden dark:block', collapsed && 'w-8'),
	};

	// Render
	return (
		<NextLink href={platformHref('/')} aria-label={alt} className={classNames.root}>
			{collapsed ? (
				<img className={classNames.logo} src={brandIcon} alt='' aria-hidden />
			) : (
				<>
					<img className={classNames.lightLogo} src={brandLogo} alt='' aria-hidden />
					<img className={classNames.darkLogo} src={brandLogoDark} alt='' aria-hidden />
				</>
			)}
		</NextLink>
	);
};
export { MktLogo };
